import { v4 as uuid } from "uuid";

export const categories = [
  {
    _id: uuid(),
    categoryName: "Rock"
  },
  {
    _id: uuid(),
    categoryName: "K-Pop"
  },
  {
    _id: uuid(),
    categoryName: "Classical"
  },
  {
    _id: uuid(),
    categoryName: "Indie"
  },
  {
    _id: uuid(),
    categoryName: "Party"
  },
  {
    _id: uuid(),
    categoryName: "Hip-hop"
  },
  {
    _id: uuid(),
    categoryName: "Bollywood"
  },
  {
    _id: uuid(),
    categoryName: "Electronic"
  },
  {
    _id: uuid(),
    categoryName: "Pop"
  }
];
